import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Label, Card, CardBody } from "reactstrap";

const CPFDisplay = ({ data }) => {
  return (
    <div className="p-3">
      <h5 className="mb-4">Dados do CPF</h5>
      <Row>
        <Col md={6}>
          <div className="mb-3">
            <Label className="fw-bold">CPF:</Label>
            <p>{data.numero_de_cpf}</p>
          </div>
        </Col>
        <Col md={6}>
          <div className="mb-3">
            <Label className="fw-bold">Nome:</Label>
            <p>{data.nome_da_pf}</p>
          </div>
        </Col>
        <Col md={6}>
          <div className="mb-3">
            <Label className="fw-bold">Data de Nascimento:</Label>
            <p>{data.data_nascimento}</p>
          </div>
        </Col>
        <Col md={6}>
          <div className="mb-3">
            <Label className="fw-bold">Situação Cadastral:</Label>
            <p>{data.situacao_cadastral}</p>
          </div>
        </Col>
        <Col md={6}>
          <div className="mb-3">
            <Label className="fw-bold">Data de Inscrição:</Label>
            <p>{data.data_inscricao}</p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const CNPJDisplay = ({ data }) => {
  return (
    <div className="p-3">
      <h5 className="mb-4">Dados do CNPJ</h5>
      
      <Card className="mb-4">
        <CardBody>
          <h6 className="mb-3">Informações Básicas</h6>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">CNPJ:</Label>
                <p>{data.numero_de_inscricao}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Nome:</Label>
                <p>{data.nome}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Nome Fantasia:</Label>
                <p>{data.fantasia}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Tipo:</Label>
                <p>{data.tipo}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Data de Abertura:</Label>
                <p>{data.abertura}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Porte:</Label>
                <p>{data.porte}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Natureza Jurídica:</Label>
                <p>{data.natureza_juridica}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Capital Social:</Label>
                <p>R$ {parseFloat(data.capital_social).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</p>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card className="mb-4">
        <CardBody>
          <h6 className="mb-3">Atividade Principal</h6>
          <div className="mb-3">
            <Label className="fw-bold">Descrição:</Label>
            <p>{data.atividade_principal.text}</p>
          </div>
          <div className="mb-3">
            <Label className="fw-bold">Código:</Label>
            <p>{data.atividade_principal.code}</p>
          </div>
        </CardBody>
      </Card>

      {data.atividades_secundarias && data.atividades_secundarias.length > 0 && (
        <Card className="mb-4">
          <CardBody>
            <h6 className="mb-3">Atividades Secundárias</h6>
            {data.atividades_secundarias.map((atividade, index) => (
              <div key={index} className="mb-3">
                <Label className="fw-bold">Atividade {index + 1}:</Label>
                <p>{atividade.text}</p>
                <small className="text-muted">Código: {atividade.code}</small>
              </div>
            ))}
          </CardBody>
        </Card>
      )}

      <Card className="mb-4">
        <CardBody>
          <h6 className="mb-3">Endereço</h6>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Logradouro:</Label>
                <p>{data.logradouro}, {data.numero}{data.complemento ? ` - ${data.complemento}` : ''}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Bairro:</Label>
                <p>{data.bairro}</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-3">
                <Label className="fw-bold">Cidade:</Label>
                <p>{data.municipio}</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-3">
                <Label className="fw-bold">UF:</Label>
                <p>{data.uf}</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-3">
                <Label className="fw-bold">CEP:</Label>
                <p>{data.cep}</p>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <h6 className="mb-3">Contato</h6>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Email:</Label>
                <p>{data.email}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Telefone:</Label>
                <p>{data.telefone}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Situação:</Label>
                <p>{data.situacao}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="fw-bold">Data da Situação:</Label>
                <p>{data.dt_situacao_cadastral}</p>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

const ConsultationModal = ({ isOpen, toggle, documentType, data }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Resultado da Consulta
      </ModalHeader>
      <ModalBody>
        {data && (
          documentType === "cpf" ? (
            <CPFDisplay data={data} />
          ) : (
            <CNPJDisplay data={data} />
          )
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConsultationModal; 